import { BLUE_WARNING_ICON } from '@Images';

export const CUSTOM_ALERT_DEFAULT_VALUES = {
  heading: 'Recipient bank details not valid',
  primaryCtaText: 'Review and confirm',
  secondaryCtaText: 'Continue anyway',
  icon: BLUE_WARNING_ICON,
  desc: 'To avoid the transaction failure in this situation, make sure you have entered the correct bank details of your recipient.',
  shareMessage: {
    confirmTitle: 'Confirm with the recipient',
    part1: 'Hi {name}!',
    part2:
      "I'm adding you as a recipient on Instarem. Could you please confirm if the following bank details are correct?",
    part3: 'Your confirmation will help ensure everything is set up properly.',
    part4: 'Thank you!',
    emailSubject: 'Verify your bank details to be added as a recipient on Instarem'
  },
  transactionFlow: {
    termsAndCondition: `By clicking Proceed & Agree, you confirm that you've 
    reviewed the recipient details and accept that the transfer may go to the wrong bank account if the details are incorrect.`,
    primaryCTA: 'Proceed & Agree',
    secondaryCTA: 'Update recipient details'
  }
};
export const CUSTOM_ALERT_INVALID_BANK_NAME = {
  heading: 'Recipient name does not match',
  primaryCtaText: 'Update recipient name',
  secondaryCtaText: 'Continue anyway',
  icon: BLUE_WARNING_ICON,
  desc: `The name you have provided does not match the account name. Please double check the 
  recipient details as an incorrect payment may be difficult to retrieve.`,
  shareMessage: {
    confirmTitle: 'Confirm with the recipient',
    part1: 'Hi {name}!',
    part2:
      "I'm adding you as a recipient on Instarem. Please confirm if the following banking name is correct:",
    part3: 'Your confirmation will help ensure everything is set up properly.',
    part4: 'Thank you!',
    emailSubject: 'Verify your bank details to be added as a recipient on Instarem'
  },
  transactionFlow: {
    termsAndCondition: `By clicking Proceed & Agree, you confirm that you've reviewed the recipient
     details and accept that the transfer may go to the wrong bank account if the details are incorrect.`,
    primaryCTA: 'Proceed & Agree',
    secondaryCTA: 'Update recipient details'
  }
};

export const CUSTOM_ALERT_INVALID_BANK_NAME_MINOR_ERROR = {
  heading: 'Recipient name close match',
  primaryCtaText: 'Update recipient name',
  secondaryCtaText: 'Continue anyway',
  icon: BLUE_WARNING_ICON,
  desc: `We've verified the recipient's banking name as ‘{NAME}’.
   To ensure a smooth transfer, please update the recipient name to match exactly.`,
  shareMessage: {
    confirmTitle: 'Confirm with the recipient',
    part1: 'Hi {name}!',
    part2:
      "I'm adding you as a recipient on Instarem. Please confirm if the following banking name is correct:",
    part3: 'Your confirmation will help ensure everything is set up properly.',
    part4: 'Thank you!',
    emailSubject: 'Verify your bank details to be added as a recipient on Instarem'
  },
  transactionFlow: {
    termsAndCondition: `By clicking Proceed & Agree, you confirm that you've reviewed 
    the recipient details and accept that the transfer may go to the wrong bank account if the details are incorrect.`,
    primaryCTA: 'Proceed & Agree',
    secondaryCTA: 'Update recipient details'
  }
};

export const CUSTOM_ALERT_BANK_VERIFICATION_ERROR = {
  heading: 'Recipient verification not available',
  primaryCtaText: 'Update recipient name',
  secondaryCtaText: 'Continue anyway',
  icon: BLUE_WARNING_ICON,
  desc: `Some recipient details, like their name or bank account, couldn’t be verified.
   To ensure a smooth and secure transfer, please double-check the details before proceeding.`,
  shareMessage: {
    confirmTitle: 'Confirm with the recipient',
    part1: 'Hi {name}!',
    part2:
      "I'm adding you as a recipient on Instarem. Please confirm if the following banking name is correct:",
    part3: 'Your confirmation will help ensure everything is set up properly.',
    part4: 'Thank you!',
    emailSubject: 'Verify your bank details to be added as a recipient on Instarem'
  },
  transactionFlow: {
    termsAndCondition: `By clicking Proceed & Agree, you confirm that you've reviewed the recipient 
    details and accept that the transfer may go to the wrong bank account if the details are incorrect.`,
    primaryCTA: 'Proceed & Agree',
    secondaryCTA: 'Update recipient details'
  }
};

export const BANK_NAME_POPUP_CONTENT = `This is the bank name related to the bank account details you’ve provided. 
Ensure it matches the recipient’s name`;

export const UNSUPPORTED_BANK_POP_UP_THB = {
  unsupportedThbBankMessage:
    'This bank is not among the major supported banks, so your transfer may incur extra fees. ',
  learnMore: 'Learn more',
  alertPopup: {
    heading: 'Important information for THB transfers',
    descriptionNote: 'Please note the following (effective as of 8 May 2025):',
    descriptionListWeb: [
      '{sameDayPayouts} applies for transfers submitted {cutoffTime}.',
      `{receivingBankFees} from incoming payments (estimated {estimatedFeeRange} but may vary). 
      Fees are determined by the beneficiary bank. Instarem does not control these charges.`
    ],
    sameDayPayouts: 'Same-day payouts',
    cutoffTime: 'before 3 PM local time (8 AM UTC)',
    receivingBankFees: 'Receiving banks may deduct fees',
    estimatedFeeRange: '100–300 THB',
    primaryCTA: 'Got it'
  }
};
